$(document).ready(function(){

    var form = $("#demandeMdpForm");
    initDemandeMdpFormValidate(form, rootUrl);
});

function initDemandeMdpFormValidate(form, rootUrl){

    $.extend($.validator.messages, {
        required: "Veuillez renseigner ce champ",
        email: "Veuillez saisir un email valide",
        remote: "Cette adresse email n'est associée à aucun compte AfterSales"
    });

    form.validate({
        onkeyup: false,
        onfocusout: false,
        errorElement: "div",
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        rules: {
            emailUtilisateur: {
                required: true,
                email: true,
                remote: {
                    url: rootUrl+"user/checkMail",
                    type: "POST",
                    data: {
                        email: function(){
                            return $("#emailUtilisateur").val();
                        }
                    }
                }
            }
        }
    });
}
